export { default as AviaTourPromoBottomSheet } from './ui/AviaTourPromoBottomSheet.vue';
export { default as AviaTourPromoBanner } from './ui/AviaTourPromoBanner.vue';
export { useAviaTourPromo } from './model/use-avia-tour-promo.ts';
export {
  AVIA_TOUR_PROMO_DISCOUNT_AMOUNT,
  AVIA_TOUR_PROMO_CODE,
} from './config';
